export const REPORT_TYPES = {
  HEADINGS_UPDATES: 'HEADINGS_UPDATES',
  FAILED_UPDATES: 'FAILED_UPDATES',
};
